var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{ref:"img",class:{ loader: !_vm.srcImg },attrs:{"src":_vm.srcImg ? _vm.srcImg : _vm.srcLoader}})}
var staticRenderFns = []

export { render, staticRenderFns }